import styled from 'styled-components'

export const FormTitle = styled.div.attrs({
})`           
    color: ${props => props.theme.palette.colors.text}; 
    font-size: 22px; 
    font-family: Gilroy;
    font-weight: 700;
`;
export const FormText = styled.div.attrs({
})`           
    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    color: ${props => props.theme.palette.colors.muted};
`;

export const FormSpacer = styled.div.attrs({
})`           
    margin-top: 40px;
`;

export const RegisterCall = styled.div.attrs({
})`           
    margin: 30px 0 0px;
    color: ${props => props.theme.palette.colors.muted};
    font-size: 15;
    font-weight: bold;
`;
export const LoginContainer = styled.div.attrs({
})`           
    background: transparent;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 32px;
`;

export const RegisterIntro = styled.div.attrs({
})`
    width: 100%;
    max-width: 720px;
    margin: 0 auto -8px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: center;
`;

export const LoginContent = styled.div.attrs({
})`           
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 24px;
`;

export const RegisterContainer = styled.div.attrs({
})` 
    background: ${props => props.theme.palette.colors.surfaceElevatedSoft};
    width: 100%;
    max-width: ${p => p.full ? `100%` : `720px`};
    height: 100%;
    padding: 40px;
    display: flex;
    margin: auto;
    flex-direction: column;
    justify-content: center;
    border-radius: ${p => p.noradius ? `0` : `28px`};
    border: 1px solid ${p => p.theme.palette.colors.borderSoft};
    box-shadow: 0 24px 56px ${p => p.theme.palette.colors.shadowStrong};
    @media(max-width: 767px){
        padding: 24px;
    }
`;

export const Container = styled.div.attrs({
})`             
    padding: 24px 0;
    border-bottom: 1px solid ${p => p.theme.palette.colors.borderSoft};
    border-top: 1px solid ${p => p.theme.palette.colors.borderSoft};
    display: flex;
    flex-direction: column;
    gap: 24px;
    margin-bottom: 12px;
`;
